// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"79":"74d0b88f","349":"6927933f","356":"c5805e87","526":"e172b035","650":"25cf123d","909":"22c67059"}[chunkId] + ".js";
};